package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.CharacterRepository

/**
 * Compte les personnages d'un joueur dans un univers.
 *
 * Utilisé par les écrans qui doivent seulement savoir si le joueur a déjà des personnages,
 * sans payer le chargement de leurs avatars.
 */
class CountCharactersInUniverseUseCase(
    private val characterRepository: CharacterRepository
) {
    suspend operator fun invoke(universeId: String, userId: String): Result<Int> {
        return characterRepository.countCharactersInUniverse(universeId, userId)
    }
}
